import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { fc } from 'i18n';
import { IDraftForm } from 'types/tep';
import Input from 'core/react/general/form/Input';

import styles from './styles.module.css';

interface IJobTypeCellProps {
  rowIndex: number;
}

export const PlateNumber: FC<IJobTypeCellProps> = ({ rowIndex }) => {
  const { formState, control } = useFormContext<IDraftForm>();

  const { errors } = formState;

  const error = errors.leases?.[rowIndex]?.plateNumber?.message;

  return (
    <>
      <Controller
        control={control}
        name={`leases.${rowIndex}.plateNumber`}
        rules={{ required: fc('please enter vehicle plate no.') }}
        defaultValue=""
        render={({ value, onChange }) => (
          <div className={styles.input}>
            <Input placeholder="enter vehicle plate no." value={value} onChange={onChange} />
            {/*TODO: error messages should be moved to corresponding form components when they are being refactored*/}
            {!!error && <div className={styles.error}>{error}</div>}
          </div>
        )}
      />
    </>
  );
};
